import {
    ORP_COMPRAS_UNOPS,
    ORP_COMPRAS_UNOPS_SUCCESS,
    ORP_COMPRAS_UNOPS_ERROR,
    ORP_COMPRAS_UNOPS_SET,
    ORP_COMPRAS_UNOPS_SEARCH_CHANGE,
    ORP_COMPRAS_UNOPS_PAGE_SET
} from '../actions';

const INIT_STATE = {
    loading: true,
    init: true,
    orpcomprasunops: {
        data: [],
        loading: true,
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            source_code: '',
            med_description: ''
        },
        value: {
            source_code: '',
            med_description: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ORP_COMPRAS_UNOPS:
            return {
                ...state,
                loading: true,
                orpcomprasunops: {
                    data: [],
                    loading: true,
                }
            }
        case ORP_COMPRAS_UNOPS_SUCCESS:
            return {
                ...state,
                loading: false,
                orpcomprasunops: {
                    ...state.orpcomprasunops,
                    ...action.payload
                }
            }
        case ORP_COMPRAS_UNOPS_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case ORP_COMPRAS_UNOPS_SET:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case ORP_COMPRAS_UNOPS_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    value: action.payload,
                }
            }
        case ORP_COMPRAS_UNOPS_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                },
                log: []
            }
        default:
            return { ...state };
    }

};